import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import auth from './auth';
import info from './info';
import notifs from './notifs';
import page from './page';

const rootReducer = combineReducers({
  auth,
  info,
  notifs,
  page,
  routing,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/modules/index.js